module.exports = "/static/assets/0f431f212115f8db3704038ea01ea09e.png";